import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SignupService } from '@app-services/signup/signup.service';
import { SignupdialogComponent } from 'src/app/modules/shared/components/signupdialog/signupdialog.component';
import { OtpLoginDialogComponent } from 'src/app/modules/shared/components/otp-login-dialog/otp-login-dialog.component';
import { TermsAndConditionsDialogComponent } from '@app-shared/components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { TenantConstant } from '@app-constants/tenant.constant';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@app-services/user/user.service';
import { RankDialogComponent } from '@app-shared/components/rank-dialog/rank-dialog.component';
import { openAdmissionLoginForm, openLoginForm } from 'src/app/helpers/methods';
import { AuthService } from '@app-services/auth-service/auth.service';
import { homeRoute } from '@app-constants/app.constants';
import { clearLocalStorage } from '@app-helpers/functions';

declare var $:any;
// import * as $ from 'jquery';
export const admissionNumberRegex = TenantConstant.portal == 'SCORE' ? /^[6-9]{10}$/i : /^((scs[0-9]{6,9})|(ts[0-9]{6,10})|([0-9]{9}))$/i;
export function signup(num: any, numberAndIsd:any) {
  if(!/^[26789][0-9]{9}/.test(numberAndIsd.number)) {
    return;
  }
  this.gaService.sendEvent(
    'start_learning',
    'start_learning_btn',
    `start_learning`,
    `clicked`,
  );
  this.gaService.sendEvent(
    `start_learning_${num}`,
    'start_learning_btn',
    `start_learning_${num}`,
    `clicked_${num}`
  );

  clearLocalStorage();
  this.signUpService.verifyPhoneNumber(numberAndIsd).subscribe((data) => {
    if (data.existingUser === false) {
      this.openSignUpDialog(numberAndIsd);
    } else if (data.existingUser === true) {
      this.openDefaultLoginDialog(numberAndIsd);
    }
  },
    (error) => {                                     // on error
      // this.errorMessage = error.error.message
    });
}
export function openSignUpDialog(numberAndIsd:any): void {
  const config: MatDialogConfig = {
    // width: '450px',
    width: '500px',
    panelClass: 'mat-full',
    id: 'new-user',
    data: {
      message: `Seems like you're a new user`,
      message2: 'Please enter your name to register',
      phone: numberAndIsd.number,
      countryCode: numberAndIsd.dialCode,
      actionData: this.data?.actionData
    }
  };
  const dialogRef = this.dialog.open(SignupdialogComponent, config);
  dialogRef.afterClosed().subscribe((value) => {
    if (value) {
      // this.revokeTokenObject(user_detail._id);
    }
  });
}

export function openDefaultLoginDialog(numberAndIsd: any) {
  //dialogRef exists if component is loginDialog or passwordLoginDIalog
  this.dialogRef?.close();
  const config: MatDialogConfig = {
    width: '439px',
    panelClass: 'mat-full',
    data: { //message: 'Password Login', message2: 'Please enter your registered phone number and password to get started', 
      message: 'OTP Login', message2: 'Please enter your registered phone number to get started',
      phone: numberAndIsd.number, countryCode: numberAndIsd.dialCode,
      actionData: this.data?.actionData
    }
  };
  const dialogRef = this.dialog.open(OtpLoginDialogComponent, config);
}

export function openTermsAndConditionsDialog(): void {
  const config: MatDialogConfig = {
    // width: '557px', 
    width: '800px',
    height: '90vh',
    panelClass: 'terms-condition-modalbox',
    data: { message: 'Terms of Use' }
  };
  const dialogRef = this.dialog.open(TermsAndConditionsDialogComponent, config);
}
export function socialMediaClicked(name) {
  this.gaService.sendEvent(
    'Social Media Icon Clicked',
    '',
    '',
    '',
    {'event': 'Social Media Icon Clicked' ,
    'Social Media Name': name}
  )
}
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  tenant: any = TenantConstant.tenant;
  portal: any = TenantConstant.portal;
  SCPlaceHolder: any = 'Phone Number';
  SCMaxLength: any = 10;
  sriChaitanyaStartForm!: FormGroup;
  customSriChaitanyaStartFormValid = true;
  sriChaitanyaStartForm1!: FormGroup;
  customSriChaitanyaStartFormValid1 = true;
  redirectionTo:any;
  rankPredictForm!: FormGroup;
  viewed: string = 'not viewed';
  ngAfterViewInit(){
    $('body').addClass('home');
    // Testimonials Slider Script
    $('.na-slider-wrapper').slick({
      passive: true,
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3500,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false
          }
        }
      ]
    });

    var rev = $('.teachers-slider-wrapper .slide-wrap');
    rev.on('init', function (event: any, slick: any, currentSlide: any) {
      var
        cur = $(slick.$slides[slick.currentSlide]),
        next = cur.next(),
        next2 = cur.next().next(),
        prev = cur.prev(),
        prev2 = cur.prev().prev();
      prev.addClass('slick-sprev');
      next.addClass('slick-snext');
      prev2.addClass('slick-sprev2');
      next2.addClass('slick-snext2');
      cur.removeClass('slick-snext').removeClass('slick-sprev').removeClass('slick-snext2').removeClass('slick-sprev2');
      slick.$prev = prev;
      slick.$next = next;
    }).on('beforeChange', function (event: any, slick: any, currentSlide: any, nextSlide: any) {
      var
        cur = $(slick.$slides[nextSlide]);
      console.log(slick.$prev, slick.$next);
      slick.$prev.removeClass('slick-sprev');
      slick.$next.removeClass('slick-snext');
      slick.$prev.prev().removeClass('slick-sprev2');
      slick.$next.next().removeClass('slick-snext2');
      var next = cur.next();
      var prev = cur.prev();
      //prev2.prev().prev();
      //next2.next().next();
      prev.addClass('slick-sprev');
      next.addClass('slick-snext');
      prev.prev().addClass('slick-sprev2');
      next.next().addClass('slick-snext2');
      slick.$prev = prev;
      slick.$next = next;
      cur.removeClass('slick-next').removeClass('slick-sprev').removeClass('slick-next2').removeClass('slick-sprev2');
    });

    // Meet our awesome teachers Script
    $('.teachers-slider-wrapper .slide-wrap').slick({
      arrows: true,
      // autoplay: true,
      // autoplaySpeed: 5000,
      slidesToShow: 1,
      infinite: true,
      // dots:true,
      centerMode: true,
      slidesPerRow: 1,
      slidesToScroll: 1,
      centerPadding: '100px',
      swipe: true,
      focusOnSelect: true,
    });

  }
  ngOnDestroy() {
    $('body').removeClass('home');
  }
  searchValue: any = '';
  signup = signup;
  openSignUpDialog = openSignUpDialog;
  openDefaultLoginDialog = openDefaultLoginDialog;
  openAdmissionLoginForm = openAdmissionLoginForm;
  openLoginForm = openLoginForm;
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  constructor(
    private dialog: MatDialog,
    public signUpService: SignupService,
    private gaService: GAnalyticsService,
    private fb:FormBuilder,
    private route: ActivatedRoute,
    public userService: UserService,
    public router: Router,
    authService: AuthService
  ) {
    if(this.portal != 'SCORE') {
      this.SCPlaceHolder = 'Admission Number';
      this.SCMaxLength = 13;
    }
   }

  ngOnInit(): void {
    window.location.href = homeRoute
    if(this.portal != 'SCORE') {
      this.sriChaitanyaStartForm = this.fb.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(admissionNumberRegex)]]
      })
      this.sriChaitanyaStartForm1 = this.fb.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(admissionNumberRegex)]]
      })
    } else {
      this.sriChaitanyaStartForm = this.fb.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]]
      })
      this.sriChaitanyaStartForm1 = this.fb.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]]
      })
    }
    this.rankPredictForm = this.fb.group({
      neetMarks: ['', [Validators.required, Validators.min(0), Validators.max(1000), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]]
    })
    this.gaService.sendEvent(
      '','','','',
      { 
        'event': 'Home Page Landing' ,
        'User Source': 'Point',
        }
    )
    this.route.queryParams.subscribe((val:any)=>{
      this.redirectionTo =  val?.returnUrl
      
      if(this.redirectionTo){
        this.openLoginForm({redirection: this.redirectionTo})
      }
     })
  }
onFacultyView(){
  if(this.viewed =='not viewed'){
    this.gaService.sendEvent('Faculty section viewed','','','',{
      'event': 'Faculty section viewed' ,
      'Navigated to which page': 'home',
    })
  }
  this.viewed = 'viewed';
}

  doSearch(value: string): void {
    this.searchValue = value;
  }

  clearLocalStorage(): void {
    clearLocalStorage();
  }

  enterKey(event: any, num: any): void {
    // console.log(this.searchValue.number.length)
    if (event.keyCode == 13 && event.target.value.length === 10) {
      this.signup(num, this.searchValue);
    }
  }

  escapeKey(event: any) {
    event.target.value = '';
  }
  gotoILITE() {
    if(this.tenant != 'srichaitanya') {
      this.router.navigateByUrl('/ilite');
    }
  }

  predictRank(){
    console.log(this.rankPredictForm.value)
    const marks = Number(this.rankPredictForm.value.neetMarks);
    if(marks < 0 || marks > 720) {
      alert("Please enter valid marks");
      return;
    }
    let rankRange = this.calculate(marks);
    const config: MatDialogConfig = {
      width: '370px',
      height: '240px',
      panelClass: 'custom-class',
      data: { message: rankRange,}
    };
    this.rankPredictForm.reset()
    this.dialog.open(RankDialogComponent,config)
  }

  calculate(marks: Number){
    console.log(marks)
    
    if (marks < 120) {
      return "Not Qualified"      
    } else if (marks <= 159) {
      return "700001 to 725000"
    } else if (marks <= 194) {
      return "500001 to 600000"
    } else if (marks <= 237) {
      return "400001 to 500000"
    } else if (marks <= 259) {
      return "350001 to 400000"
    } else if (marks <= 284) {
      return "300001 to 350000"
    } else if (marks <= 337) {
      return "250001 to 300000"
    } else if (marks <= 359) {
      return "200001 to 250000"
    } else if (marks <= 379) {
      return "180001 to 200000"
    } else if (marks <= 398) {
      return "160001 to 180000"
    } else if (marks <= 412) {
      return "140001 to 160000"
    } else if (marks <= 432) {
      return "120001 to 140000"
    } else if (marks <= 454) {
      return "100001 to 120000"
    } else if (marks <= 464) {
      return "90001 to 100000"
    } else if (marks <= 479) {
      return "80001 to 90000"
    } else if (marks <= 495) {
      return "70000 to 80000"
    } else if (marks <= 509) {
      return "60001 to 70000"
    } else if (marks <= 523) {
      return "50001 to 60000"
    } else if (marks <= 537) {
      return "40001 to 50000"
    } else if (marks <= 557) {
      return "30001 to 40000"
    } else if (marks <= 567) {
      return "250001 to 30000"
    } else if (marks <= 577) {
      return "20000 to 25000"
    } else if (marks <= 589) {
      return "15001 to 20000"
    } else if (marks <= 604) {
      return "10001 to 15000"
    } else if (marks <= 611) {
      return "8001 to 10000"
    } else if (marks <= 620) {
      return "7001 to 8000"
    } else if (marks <= 629) {
      return "5001 to 7000"
    } else if (marks <= 639) {
      return "3001 to 5000"
    } else if (marks <= 650) {
      return "2001 to 3000"
    } else if (marks <= 666) {
      return "1001 to 2000"
    } else if (marks <= 679) {
      return "501 to 1000"
    } else if (marks <= 699) {
      return "101 to 500"
    } else if (marks <= 710) {
      return "11 to 100"
    } else {
      return "1 to 10"
    }
  }
}
